import React from 'react';
import ChecklistList from './ChecklistList';

const ChecklistModule: React.FC = () => {
  return (
    <div>      
      <ChecklistList />
    </div>
  );
};

export default ChecklistModule;
